import { UIActions, UIState, UITypes } from "../../actions";

export const uiReducer = (state: UIState, action: UIActions) => {
    const types: Array<string> = Object.values(UITypes);
    const myType = types.includes(action.type);
    if (myType) {
        return {
            ...action.payload,
        };
    } else {
        return state;
    }
};